module.exports = __webpack_public_path__ + "img/43.8b051305.png";